<!--  -->
<template>
  <div class="service">
    <div class="tips">优质的客户服务</div>
    <div>以服务质量求发展</div>
    <div class="twinMain">
      <div class="serviceLeft">
        <div class="tipc">节约成本</div>
        <div>提高效率</div>
        <div>方案制定</div>
        <div>持续升级</div>
      </div>
      <div class="serviceRight">
        <div class="head">节约成本</div>
        <div>降低固定成本：灵活调整员工数量，按需付费，避免人力资源闲置</div>
        <div>
          优化薪酬结构：按小时或项目计酬，根据实际工作量支付薪酬，减少加班成本，有效分担工作量
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.service {
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 36px;
  padding: 80px 360px 0 360px;
  // height: 446px;
  background: url("@/assets/Slice3.png") no-repeat;
  background-size: 100% 100%;
  .tips {
    font-weight: 500;
    font-size: 28px;
    color: #ffffff;
    margin-bottom: 5px;
  }
  .twinMain {
    margin-top: 85px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 0px 0px 0px 0px;
    display: flex;
  }
}
.serviceLeft {
  background: rgba(0, 0, 0, 0.2);
  padding: 10px 10px 20px 10px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .tipc {
    background: #1c87ff;
    padding: 12px 24px;
  }
  div {
    // margin-bottom: 24px;
  }
}
.serviceRight {
  font-weight: 400;
  font-size: 14px;
  text-align: left;
  color: #ffffff;
  padding: 67px 90px;
  .head {
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 20px;
  }
  div {
    margin-bottom: 10px;
  }
}
</style>
